import type {
  AdminOverviewDto,
  AdminVerificationQueueItemDto,
  AdminVerificationQueueQuery,
  DecideOrganizationVerificationInput,
  SignedDocumentUrlDto,
  AdminUserListDto,
  AdminUserListQuery,
  DecideModerationInput,
  ModerationQueueItemDetailDto,
  ModerationQueueItemDto,
  ModerationQueueQuery,
  PaginatedResult,
  SignalRunResultDto,
} from '@icebreaker/shared';
import { api } from '@/shared/api/client';

/** Admin panel `api` katmanı (Epic 11) — YALNIZCA sagalardan çağrılır. */

export async function fetchAdminUsers(query: AdminUserListQuery): Promise<AdminUserListDto> {
  return await api.admin.users({
    query: query.query || undefined,
    filter: query.filter,
    page: query.page,
    pageSize: query.pageSize,
  });
}

export async function suspendUser(userId: string, reason: string): Promise<void> {
  await api.admin.suspendUser(userId, { reason });
}

export async function unsuspendUser(userId: string, reason: string): Promise<void> {
  await api.admin.unsuspendUser(userId, { reason });
}

export async function fetchModerationQueue(
  query: ModerationQueueQuery,
): Promise<PaginatedResult<ModerationQueueItemDto>> {
  return await api.admin.moderationQueue({
    status: query.status,
    itemType: query.itemType,
    page: query.page,
    pageSize: query.pageSize,
  });
}

export async function fetchModerationItem(itemId: string): Promise<ModerationQueueItemDetailDto> {
  return await api.admin.moderationItem(itemId);
}

export async function decideModeration(
  itemId: string,
  input: DecideModerationInput,
): Promise<ModerationQueueItemDetailDto> {
  return await api.admin.decideModeration(itemId, input);
}

export async function runSignals(): Promise<SignalRunResultDto> {
  return await api.admin.runSignals();
}

export async function fetchAdminOverview(): Promise<AdminOverviewDto> {
  return await api.admin.overview();
}

// --- Kurum doğrulama kuyruğu (Story 18.4) -----------------------------------

export async function fetchVerificationQueue(
  query: AdminVerificationQueueQuery,
): Promise<PaginatedResult<AdminVerificationQueueItemDto>> {
  return await api.admin.organizationVerifications({
    status: query.status,
    page: query.page,
    pageSize: query.pageSize,
  });
}

/**
 * Belgeye imzalı ve SÜRELİ bağlantı. Bağlantı üretimi sunucuda denetim kaydına
 * yazılır (admin UUID + başvuru UUID) — bu yüzden yalnız tıklandığında istenir.
 */
export async function fetchVerificationDocumentUrl(
  requestId: string,
): Promise<SignedDocumentUrlDto> {
  return await api.admin.organizationVerificationDocument(requestId);
}

export async function decideVerification(
  requestId: string,
  input: DecideOrganizationVerificationInput,
): Promise<AdminVerificationQueueItemDto> {
  return await api.admin.decideOrganizationVerification(requestId, input);
}
